export interface TokenPack {
	id: string;
	amountLabel: string;
	tokens: number;
	priceCents: number;
	featured?: boolean;
}

export const MOCK_TOKEN_PACKS: TokenPack[] = [
	{ id: '500k', amountLabel: '500 mil', tokens: 500_000, priceCents: 3900 },
	{
		id: '2m',
		amountLabel: '2 milhões',
		tokens: 2_000_000,
		priceCents: 12900,
		featured: true,
	},
	{ id: '6m', amountLabel: '6 milhões', tokens: 6_000_000, priceCents: 32900 },
];
